// 金综链中转页面
const blockChainRouterConfigs = [
  {
    path: '/blockChain',
    name: 'blockChain',
    meta: { routeName: '金综链' },
    component: () => import('@/views/blockChain/index')
  }
]

export default blockChainRouterConfigs
